import { render, staticRenderFns } from "./HsabExpenseCardRowExpanded.vue?vue&type=template&id=32a1c494"
import script from "./HsabExpenseCardRowExpanded.vue?vue&type=script&lang=ts"
export * from "./HsabExpenseCardRowExpanded.vue?vue&type=script&lang=ts"
import style0 from "./HsabExpenseCardRowExpanded.vue?vue&type=style&index=0&id=32a1c494&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports